import { PreloadingStrategy } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PreloadSelectedModulesList implements PreloadingStrategy {
  // eslint-disable-next-line @typescript-eslint/ban-types
  preload(route: any, load: Function): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}
